<template>
  <b-form-select
    v-model="inputVal"
    :options="options"
    :name="name"
    :disabled="readonly || disabled || !international"
    :placeholder="placeholder"
    @change="onChanged"
  />
</template>


<script>
export default {
  props: {
    value: {
      type: [String, Number, Boolean, Array, Object],
      default: undefined
    },
    options: {
      type: Array,
      default: function() {
        return [
          {
            text: 'KRW',
            value: 'KRW'
          },
          {
            text: 'CNY',
            value: 'CNY'
          },
          {
            text: 'USD',
            value: 'USD'
          },
          {
            text: 'EUR',
            value: 'EUR'
          },
          {
            text: 'JPY',
            value: 'JPY'
          },
          {
            text: 'VND',
            value: 'VND'
          }
        ]
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputVal: '',
      international: true
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    }
  },
  mounted() {
    this.inputVal = this.value
    this.international = this.configs.only_for_korea_republic_of !== 'true'
    if (!this.international || !this.inputVal) {
      this.inputVal = 'KRW'
      this.onChanged()
    }
  },
  methods: {
    onChanged() {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
    }
  }
}
</script>
